<template>
  <div class="appointmentCheckPage">
    <div class="tabsWrap">
      <Tabs v-model="activeKey" @change="tabChange">
        <TabPane :key="1" tab="待领取"/>
        <TabPane :key="2" tab="处理中"/>
        <TabPane :key="3" tab="我的病例"/>
        <TabPane :key="4" tab="全部病例" v-if="hasRoleScreeningReview"/>
      </Tabs>
    </div>
    <div class="searchForm">
      <header class="header" v-if="activeKey == 1">
        <Card :bordered="false">
          <Form>
            <Row :gutter="24">
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="receiveList.searchForm.hospitalId" allowClear placeholder="请选择医院">
                  <Option v-for="hospital in hospitalList" :key="hospital.id" :value="hospital.id">{{ hospital.name }}</Option>
                </Select>
              </Col>
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="receiveList.searchForm.deviceType" allowClear placeholder="请选择设备类型">
                  <Option v-for="device in deviceTypeList" :key="device.id" :value="device.value">{{ device.label }}</Option>
                </Select>
              </Col>
              <Col :span="5">
                <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="receiveList.searchForm.startAndEndTime"></RangePicker>
              </Col>
              <Col :span="3">
                <Input type="text" allowClear v-model.trim="receiveList.searchForm.keyword" :maxlength="50" @pressEnter="getReceivePageList" placeholder="请输入报告影像编号/姓名"/>
              </Col>
              <Col :xs="4" :sm="4" :md="4">
                <Button type="primary" @click="getReceivePageList(1)">搜索</Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </header>
      <header class="header" v-else-if="activeKey == 2">
        <Card :bordered="false">
          <Form>
            <Row :gutter="24">
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="processList.searchForm.hospitalId" allowClear placeholder="请选择医院">
                  <Option v-for="hospital in hospitalList" :key="hospital.id" :value="hospital.id">{{ hospital.name }}</Option>
                </Select>
              </Col>
              <Col :span="3" v-if="hasRoleScreeningReview">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="processList.searchForm.userId" allowClear placeholder="请选择诊断医生">
                  <Option v-for="doctor in writeDoctorList" :key="doctor.id" :value="doctor.id">{{ doctor.user_name }}</Option>
                </Select>
              </Col>
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="processList.searchForm.deviceType" allowClear placeholder="请选择设备类型">
                  <Option v-for="device in deviceTypeList" :key="device.id" :value="device.value">{{ device.label }}</Option>
                </Select>
              </Col>
              <Col :span="5">
                <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="processList.searchForm.startAndEndTime"></RangePicker>
              </Col>
              <Col :span="3">
                <Input type="text" allowClear v-model.trim="processList.searchForm.keyword" :maxlength="50" @pressEnter="getProcessList" placeholder="请输入报告影像编号/姓名"/>
              </Col>
              <Col :xs="4" :sm="4" :md="4">
                <Button type="primary" @click="getProcessList(1)">搜索</Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </header>
      <header class="header" v-else-if="activeKey == 3">
        <Card :bordered="false">
          <Form>
            <Row :gutter="24">
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="myList.searchForm.hospitalId" allowClear placeholder="请选择医院">
                  <Option v-for="hospital in hospitalList" :key="hospital.id" :value="hospital.id">{{ hospital.name }}</Option>
                </Select>
              </Col>
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="myList.searchForm.deviceType" allowClear placeholder="请选择设备类型">
                  <Option v-for="device in deviceTypeList" :key="device.id" :value="device.value">{{ device.label }}</Option>
                </Select>
              </Col>
              <Col :span="5">
                <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="myList.searchForm.startAndEndTime"></RangePicker>
              </Col>
              <Col :span="3">
                <Input type="text" allowClear v-model.trim="myList.searchForm.keyword" :maxlength="50" @pressEnter="getMyList" placeholder="请输入报告影像编号/姓名"/>
              </Col>
              <Col :xs="4" :sm="4" :md="4">
                <Button type="primary" @click="getMyList(1)">搜索</Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </header>
      <header class="header" v-else-if="activeKey == 4">
        <Card :bordered="false">
          <Form>
            <Row :gutter="24">
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="allList.searchForm.hospitalId" allowClear placeholder="请选择医院">
                  <Option v-for="hospital in hospitalList" :key="hospital.id" :value="hospital.id">{{ hospital.name }}</Option>
                </Select>
              </Col>
              <Col :span="3" v-if="[2, 4].includes(activeKey)">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="allList.searchForm.userId" allowClear placeholder="请选择诊断医生">
                  <Option v-for="doctor in writeDoctorList" :key="doctor.id" :value="doctor.id">{{ doctor.user_name }}</Option>
                </Select>
              </Col>
              <Col :span="3">
                <Select :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model="allList.searchForm.deviceType" allowClear placeholder="请选择设备类型">
                  <Option v-for="device in deviceTypeList" :key="device.id" :value="device.value">{{ device.label }}</Option>
                </Select>
              </Col>
              <Col :span="5">
                <RangePicker :getPopupContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" v-model.trim="allList.searchForm.startAndEndTime"></RangePicker>
              </Col>
              <Col :span="3">
                <Input type="text" allowClear v-model.trim="allList.searchForm.keyword" :maxlength="50" @pressEnter="getAllList" placeholder="请输入报告影像编号/姓名"/>
              </Col>
              <Col :xs="4" :sm="4" :md="4">
                <Button type="primary" style="display: inline-block;" @click="getAllList(1)">搜索</Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </header>
    </div>
    <!-- 列表展示 -->
    <article class="content">
      <!-- 待领取 -->
      <Table tableLayout="fixed" v-if="activeKey == 1" :loading="receiveList.tableLoading" :dataSource="receiveList.list" :columns="receiveColumns" :pagination='false' rowKey="id">
        <template slot="patientSex" slot-scope="text, record">
          <span v-if="record.patient_sex == 1">男</span>
          <span v-else-if="record.patient_sex == 2">女</span>
        </template>
        <template slot="aligorthmStatus" slot-scope="text, record">
          <span v-if="record.aligorthm_status === 0">待运算</span>
          <span v-else-if="record.aligorthm_status === 2">运算中</span>
          <span v-else-if="record.aligorthm_status === 10">运算成功</span>
          <span v-else-if="record.aligorthm_status === 1" style="color:red;">运算失败</span>
        </template>

        <template slot="algorithmResult" slot-scope="text, record">
          <span v-if="!record.aligorthm_result"></span>
          <Tag color="red" v-else-if="record.aligorthm_result['阳性']">阳性</Tag>
          <Tag v-else>阴性</Tag>
        </template>

        <template slot="algorithmResultDesc" slot-scope="text, record">
          <span>{{ record.aligorthm_result && record.aligorthm_result['算法结果说明']}}</span>
        </template>

        <div slot="control" slot-scope="text, record">
          <Button type="primary" size="small" style="margin-right: 8px;" @click="receiveRecord(record)">
            <b>领取</b>
          </Button>
          <Button size="small" style="margin-right: 8px;" @click="watchImage(record)">
            <b>查看影像</b>
          </Button>
        </div>
      </Table>
      <!-- 处理中 -->
      <Table tableLayout="fixed" v-if="activeKey == 2" :loading="processList.tableLoading" :dataSource="processList.list" :columns="processColumns" :pagination='false' rowKey="id">
        <template slot="patientSex" slot-scope="text, record">
          <span v-if="record.patient_sex == 1">男</span>
          <span v-else-if="record.patient_sex == 2">女</span>
        </template>
        <template slot="aligorthmStatus" slot-scope="text, record">
          <span v-if="record.aligorthm_status === 0">待运算</span>
          <span v-else-if="record.aligorthm_status === 2">运算中</span>
          <span v-else-if="record.aligorthm_status === 10">运算成功</span>
          <span v-else-if="record.aligorthm_status === 1" style="color:red;">运算失败</span>
        </template>
        <template slot="algorithmResult" slot-scope="text, record">
          <span v-if="!record.aligorthm_result"></span>
          <Tag color="red" v-else-if="record.aligorthm_result['阳性']">阳性</Tag>
          <Tag v-else>阴性</Tag>
        </template>

        <template slot="algorithmResultDesc" slot-scope="text, record">
          <span>{{ record.aligorthm_result && record.aligorthm_result['算法结果说明'] }}</span>
        </template>

        <div slot="control" slot-scope="text, record">
          <Button size="small" style="margin-right: 8px;" v-if="record.user_id === userId" @click="giveUpRecord(record)">
            <b>放弃</b>
          </Button>
          <Button size="small" style="margin-right: 8px;" @click="watchImage(record)">
            <b>查看影像</b>
          </Button>
          <Button size="small" style="margin-right: 8px;" @click="downLoadSegement(record)">
            <b>下载分割文件</b>
          </Button>
          <Button v-if="record.user_id === userId" type="primary" size="small" style="margin-right: 8px;"  @click="showNormalModal(record)">
            <b>确定阴性</b>
          </Button>
          <Button v-if="record.user_id === userId" type="danger" size="small" style="margin-right: 8px;" @click="showAbnormalModal(record)">
            <b>确定阳性</b>
          </Button>
          <upload v-if="record.user_id === userId" :showUploadList="false" accept=".zip,.rar" :customRequest="(event) => markFileUpload(record, event.file)">
            <Button size="small" style="margin-right: 8px;" :loading="record.uploadMarkFileLoading" :disabled="record.uploadMarkFileLoading">{{ record.uploadMarkFileLoading?'上传中': '上传标注文件' }}</Button>
          </upload>
          <Button size="small" style="margin-right: 8px; background-color: #f50; color: white;" @click="showImgNotMatchModal(record)">
            <b>图像不符</b>
          </Button>
        </div>
      </Table>
       <!-- 我的病例 -->
      <Table tableLayout="fixed" v-if="activeKey == 3" :loading="myList.tableLoading" :dataSource="myList.list" :columns="myColumns" :pagination='false' rowKey="id">
        <template slot="patientSex" slot-scope="text, record">
          <span v-if="record.patient_sex == 1">男</span>
          <span v-else-if="record.patient_sex == 2">女</span>
        </template>
        <template slot="aligorthmStatus" slot-scope="text, record">
          <span v-if="record.aligorthm_status === 0">待运算</span>
          <span v-else-if="record.aligorthm_status === 2">运算中</span>
          <span v-else-if="record.aligorthm_status === 10">运算成功</span>
          <span v-else-if="record.aligorthm_status === 1" style="color:red;">运算失败</span>
        </template>
        <template slot="doctorResult" slot-scope="text, record">
          <Tag v-if="(record.status === 100) && (!record.inspection_result)">阴性</Tag>
          <div v-else>
            <Tag color="red" v-for="item in record.inspection_result" :key="item">{{ item }}</Tag>
          </div>
        </template>
        <template slot="algorithmResult" slot-scope="text, record">
          <span v-if="!record.aligorthm_result"></span>
          <Tag color="red" v-else-if="record.aligorthm_result['阳性']">阳性</Tag>
          <Tag v-else>阴性</Tag>
        </template>

        <template slot="algorithmResultDesc" slot-scope="text, record">
          <span>{{ record.aligorthm_result && record.aligorthm_result['算法结果说明']}}</span>
        </template>

        <template slot="status" slot-scope="text, record">
          <span v-if="record.status === 0">算法处理中</span>
          <span v-else-if="record.status === 1">待领取</span>
          <span v-if="record.status === 10">处理中</span>
          <span v-else-if="record.status === 100">已完成</span>
        </template>
        <div slot="control" slot-scope="text, record">
          <Button size="small" v-if="record.inspection_result" style="margin-right: 8px;" @click="showDiagnoseDetail(record)">阳性诊断详情</Button>
          <Button size="small" style="margin-right: 8px;" @click="downLoadSegement(record)">
            <b>下载分割文件</b>
          </Button>
          <upload :showUploadList="false" accept=".zip,.rar" style="display:inline-block;" v-if="!record.mark_file" :customRequest="(event) => markFileUpload(record, event.file)">
            <Button size="small" style="margin-right: 8px;" :loading="record.uploadMarkFileLoading" :disabled="record.uploadMarkFileLoading">{{ record.uploadMarkFileLoading?'上传中': '上传标注文件' }}</Button>
          </upload>
          <Button size="small" v-else style="margin-right: 8px;" @click="downLoadMarkFile(record)">
            <b>下载标注文件</b>
          </Button>
        </div>
      </Table>
       <!-- 全部病例 -->
      <Table tableLayout="fixed" v-if="activeKey == 4" :loading="allList.tableLoading" :dataSource="allList.list" :columns="allColumns" :pagination='false' rowKey="id">
        <template slot="patientSex" slot-scope="text, record">
          <span v-if="record.patient_sex == 1">男</span>
          <span v-else-if="record.patient_sex == 2">女</span>
        </template>
        <template slot="aligorthmStatus" slot-scope="text, record">
          <span v-if="record.aligorthm_status === 0">待运算</span>
          <span v-else-if="record.aligorthm_status === 2">运算中</span>
          <span v-else-if="record.aligorthm_status === 10">运算成功</span>
          <span v-else-if="record.aligorthm_status === 1" style="color:red;">运算失败</span>
        </template>
        <template slot="algorithmResult" slot-scope="text, record">
          <span v-if="!record.aligorthm_result"></span>
          <Tag color="red" v-else-if="record.aligorthm_result['阳性']">阳性</Tag>
          <Tag v-else>阴性</Tag>
        </template>

        <template slot="algorithmResultDesc" slot-scope="text, record">
          <span>{{ record.aligorthm_result && record.aligorthm_result['算法结果说明'] }}</span>
        </template>

        <template slot="doctorResult" slot-scope="text, record">
          <Tag v-if="(record.status === 100) && (!record.inspection_result)">阴性</Tag>
          <div v-else>
            <Tag color="red" v-for="item in record.inspection_result" :key="item">{{ item }}</Tag>
          </div>
        </template>
        <template slot="status" slot-scope="text, record">
          <span v-if="record.status === 0">算法处理中</span>
          <span v-else-if="record.status === 1">待领取</span>
          <span v-if="record.status === 10">处理中</span>
          <span v-else-if="record.status === 100">已完成</span>
        </template>
        <div slot="control" slot-scope="text, record">
          <div v-if="record.status === 100 && record.inspection_result" style="display:inline-block;margin-right: 8px;">
            <Button size="small" @click="showDiagnoseDetail(record)">阳性诊断详情</Button>
            <Button v-if="hasRoleScreeningReview" type="danger" size="small" style="margin-left: 8px;"  @click="showNormalModal(record)">
              <b>修改为阴性</b>
            </Button>
          </div>
          <Button v-if="record.status === 100 && !record.inspection_result" type="danger" size="small" style="margin-right: 8px;" @click="showAbnormalModal(record)">
            <b>修改为阳性</b>
          </Button>
          <Button size="small" style="margin-right: 8px;" @click="downLoadSegement(record)">
            <b>下载分割文件</b>
          </Button>
          <Button v-if="record.status === 100 && record.mark_file" size="small" style="margin-right: 8px;" @click="downLoadMarkFile(record)">
            <b>下载标注文件</b>
          </Button>
        </div>
      </Table>
    </article>
    <!-- 页脚内容 -->
    <footer class="footer">
      <div class="page">
        <Pagination v-if="activeKey === 2" v-model="processList.pageNumber" :pageSize.sync="processList.pageSize" :showQuickJumper='true' :total="processList.totalRecord" @change="getProcessList" />
        <Pagination v-if="activeKey === 3" v-model="myList.pageNumber" :pageSize.sync="myList.pageSize" :showQuickJumper='true' :total="myList.totalRecord" @change="getMyList" />
        <Pagination v-if="activeKey === 4" v-model="allList.pageNumber" :pageSize.sync="allList.pageSize" :showQuickJumper='true' :total="allList.totalRecord" @change="getAllList" />
      </div>
    </footer>
    <!-- 领取 -->
    <Modal title="提示" v-model="receiveModal.visible" :confirmLoading="receiveModal.confirmLoading" width="40%" @ok="sureReceive" @cancel="closeReceiveModal">
      <div>
        <p>确认领取此病例？</p>
        <p>领取后，其他医生将不能再领取</p>
      </div>
    </Modal>
    <!-- 放弃 -->
    <Modal title="提示" v-model="abandonModal.visible" :confirmLoading="abandonModal.confirmLoading" width="40%" @ok="sureGiveUp">
      <div>
        <p>是否放弃？</p>
        <p>放弃后，病例将会被其他医生领取</p>
      </div>
    </Modal>
    <!-- 确定阴性 -->
    <Modal title="提示" v-model="normalModal.visible" :confirmLoading="normalModal.confirmLoading" width="40%" @ok="sureFeminine">
      <div>
        <p>确定病例为阴性吗？</p>
        <p>确定之后将不能修改，并且会将结果通知给运营人员。</p>
      </div>
    </Modal>
    <!-- 确定阳性 -->
    <Modal title="诊断详情" class="abnormalModal" :footer="null" v-model="abnormalModal.visible" :width="1120" @cancel="closeAbnormalModal">
      <div class="abnormalModalContent">
        <div style="max-height: 542px; overflow-y: auto;">
          <Form>
            <FormItem>
              <span slot="label">
                <span>诊断结果</span>
                <span style="color: red;">(支持多选)</span>
              </span>
              <Select mode="multiple" v-model="abnormalModal.diseaseType" allowClear placeholder="请选择诊断结果" :disabled="!hasRoleScreeningReview && abnormalModal.onlyShowFlag">
                <Option :value="'血管狭窄'">血管狭窄</Option>
                <Option :value="'动脉瘤'">动脉瘤</Option>
              </Select>
            </FormItem>
            <FormItem label="诊断描述">
              <TextArea v-model="abnormalModal.abnormalReason" :auto-size="{ minRows: 4, maxRows: 6 }" placeholder="诊断描述" :disabled="!hasRoleScreeningReview && abnormalModal.onlyShowFlag"/>
            </FormItem>
            <FormItem label="诊断依据">
              <div class="onlyImage">
                <div class="pasteImage" v-for="(imageItem, numIndex) in abnormalModal.imageList" :key="numIndex">
                  <div class="imageWrap" v-if="imageItem && imageItem.url">
                    <img :src="imageItem.url"/>
                    <div class="delAndPrev">
                      <Icon type="eye" style="font-size:30px; margin-right:15px;"  @click="previewImage(numIndex)"/>
                      <Icon type="delete" v-if="(!abnormalModal.onlyShowFlag) || hasRoleScreeningReview" style="font-size:30px;" @click="deleteImage(numIndex)"/>
                    </div>
                  </div>
                </div>
                <div class="pasteImage"  v-on:paste="selectPaste" v-if="(!abnormalModal.onlyShowFlag) || hasRoleScreeningReview">
                  <div class="pasteTip">
                    <Icon type="picture" style="font-size:60px;"/>
                    <span style="margin-top:8px;">点击此处，然后按Ctrl+V粘贴图片</span>
                  </div>
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
        <div class="abnormalModalFooter ant-modal-footer" v-if="hasRoleScreeningReview || (!abnormalModal.onlyShowFlag)">
          <Button @click="closeAbnormalModal">取消</Button>
          <Button type="primary" @click="surePositive" :loading="abnormalModal.confirmLoading" :disabled="abnormalModal.confirmLoading">确定</Button>
        </div>
      </div>
    </Modal>
    <Modal title="提示" v-model="imgNotMatchModal.visible" :confirmLoading="imgNotMatchModal.confirmLoading" width="40%" @ok="sureImgNotMatch" @cancel="closeImgNotMatchModal">
      <div>
        <p>确定病例图像不符吗？</p>
        <div style="margin-top: 10px;">
          <p>不符的原因</p>
          <TextArea v-model="imgNotMatchModal.reason" :auto-size="{ minRows: 4, maxRows: 6 }" placeholder="请输入图像不符原因"/>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { Tabs, Form, Tag, Upload, Icon, Input, DatePicker, Select, Row, Col, Button, Table, Pagination, Card, Modal } from 'ant-design-vue'
import { fixTableHeader, WatchImageByWeasisOrOsrix } from '../../libs/mixin'
import { findPage, receiveAction, giveUpAction, saveAction, uploadFile, getWeasisUrlByFilmNo, uploadMarkFile, getHospitalList } from '../../api/screening'
import { getSession, isObject, toast, setCurrentUrl, getParamFromRoute, downLoadFile, setLocal, getLocal } from '../../libs/utils'
import { getWriteDoctorList } from '../../api/check'
import { isNumber, isArray, isString } from 'lodash'
import moment from 'moment'
import { api as viewerApi } from 'v-viewer'
export default {
  mixins: [fixTableHeader, WatchImageByWeasisOrOsrix],
  components: {
    Icon,
    Tag,
    Tabs,
    TabPane: Tabs.TabPane,
    Form,
    FormItem: Form.Item,
    Input,
    Upload,
    TextArea: Input.TextArea,
    RangePicker: DatePicker.RangePicker,
    Select,
    Option: Select.Option,
    Row,
    Col,
    Button,
    Table,
    Pagination,
    Card,
    Modal,
  },
  data () {
    const commonColums = [
      {
        title: '病例来源',
        dataIndex: 'hospital_name',
        width: 100
      },
      {
        title: '患者姓名',
        dataIndex: 'patient_name',
        width: 100
      },
      {
        title: '年龄',
        dataIndex: 'patient_age',
        width: 50
      },
      {
        title: '性别',
        scopedSlots: { customRender: 'patientSex' },
        width: 40
      },
      {
        title: '上传时间',
        dataIndex: 'created_date',
        width: 90
      },
      {
        title: '影像编号',
        dataIndex: 'film_no',
        width: 110
      },
      {
        title: '设备类型',
        dataIndex: 'device_type',
        width: 70
      },
      {
        title: '算法状态',
        key: 'aligorthmStatus',
        scopedSlots: { customRender: 'aligorthmStatus' },
        width: 70
      },
      {
        title: '算法判定结果',
        key: 'algorithmResult',
        scopedSlots: { customRender: 'algorithmResult' },
        width: 100
      },
    ]
    const risUserInfo = getSession('risUserInfo', 'object') || {}
    const userId = risUserInfo.id
    return {
      userId: userId,
      activeKey: 1,
      writeDoctorList: [],
      hospitalList: [],
      deviceTypeList: [
        {
          id: 1,
          value: 'MR',
          label: 'MR'
        },
        {
          id: 2,
          value: 'CT',
          label: 'CT'
        },
        {
          id: 3,
          value: 'DR',
          label: 'DR'
        }
      ],
      receiveColumns: [
        ...commonColums,
        {
          title: '算法结果说明',
          key: 'algorithmResultDesc',
          scopedSlots: { customRender: 'algorithmResultDesc' },
          width: 200
        },
        {
          title: '操作',
          dataIndex: 'control',
          scopedSlots: { customRender: 'control' },
          width: 250
        }
      ],
      receiveList: {
        pageNumber: 1,
        pageSize: 1000,
        list: [],
        tableLoading: false,
        searchForm: {
          hospitalId: undefined,
          deviceType: undefined,
          startAndEndTime: [],
          keyword: ''
        }
      },
      processColumns: [
        ...commonColums,
        {
          title: '算法结果说明',
          key: 'algorithmResultDesc',
          scopedSlots: { customRender: 'algorithmResultDesc' },
          width: 200
        },
        {
          title: '操作',
          dataIndex: 'control',
          scopedSlots: { customRender: 'control' }
        }
      ],
      processList: {
        pageNumber: 1,
        pageSize: 15,
        totalRecord: 0,
        list: [],
        tableLoading: false,
        searchForm: {
          hospitalId: undefined,
          userId: undefined,
          deviceType: undefined,
          startAndEndTime: [],
          keyword: ''
        }
      },
      myList: {
        pageNumber: 1,
        pageSize: 15,
        totalRecord: 0,
        list: [],
        tableLoading: false,
        searchForm: {
          hospitalId: undefined,
          userId: undefined,
          deviceType: undefined,
          startAndEndTime: [],
          keyword: ''
        }
      },
      myColumns: [
        ...commonColums,
        {
          title: '算法结果说明',
          key: 'algorithmResultDesc',
          scopedSlots: { customRender: 'algorithmResultDesc' },
          width: 200
        },
        {
          title: '医生判定结果',
          key: 'doctorResult',
          scopedSlots: { customRender: 'doctorResult' },
          width: 130
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 70
        },
        {
          title: '操作',
          dataIndex: 'control',
          scopedSlots: { customRender: 'control' },
          width: 300
        }
      ],
      allList: {
        pageNumber: 1,
        pageSize: 20,
        totalRecord: 0,
        list: [],
        tableLoading: false,
        searchForm: {
          hospitalId: undefined,
          userId: undefined,
          deviceType: undefined,
          startAndEndTime: [],
          keyword: ''
        }
      },
      allColumns: [
        ...commonColums,
        {
          title: '算法结果说明',
          key: 'algorithmResultDesc',
          scopedSlots: { customRender: 'algorithmResultDesc' },
          width: 200
        },
        {
          title: '判定医生',
          dataIndex: 'user_name',
          width: 80
        },
        {
          title: '医生判定结果',
          key: 'doctorResult',
          scopedSlots: { customRender: 'doctorResult' },
          width: 130
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 70
        },
        {
          title: '操作',
          dataIndex: 'control',
          scopedSlots: { customRender: 'control' }
        }
      ],
      receiveModal: {
        visible: false,
        confirmLoading: false,
        record: null
      },
      abandonModal: {
        visible: false,
        confirmLoading: false,
        record: null
      },
      normalModal: {
        visible: false,
        confirmLoading: false,
        record: null
      },
      abnormalModal:{
        visible: false,
        confirmLoading: false,
        record: null,
        abnormalReason: '',
        diseaseType: undefined,
        imageList: [],
        onlyShowFlag: false
      },
      hasRoleScreeningReview: false,
      imgNotMatchModal: {
        visible: false,
        confirmLoading: false,
        record: null,
        reason: ''
      },
    }
  },
  watch: {
    activeKey (newKey) {
      if (newKey === 1) {
        const timer = setInterval(() => {
          this.getReceivePageList()
        }, 6000)
        setLocal('screeningTimer', timer)
      } else {
        this.clearTimer()
      }
    }
  },
  methods: {
    async tabChange (val) {
      this.activeKey = val
      await this.getPageList()
    },
    async getPageList () {
      const activeKey = this.activeKey
      if (activeKey === 1) {
        await this.getReceivePageList()
      } else if (activeKey === 2) {
        await this.getProcessList(this.processList.pageNumber)
      } else if (activeKey === 3) {
        await this.getMyList(this.myList.pageNumber)
      } else if (activeKey === 4) {
        await this.getAllList(this.allList.pageNumber)
      }
    },
    async getReceivePageList () {
      try {
        const params = {
          pageNumber: 1,
          pageSize: 1000,
          status: 1,
          type: 1
        }
        const postParams = Object.assign(params, this.createSearchParams(this.receiveList.searchForm))
        delete postParams.startAndEndTime
        this.tableLoading = true
        setCurrentUrl(Object.assign({ activeKey: this.activeKey }, postParams))
        const list = await findPage(postParams)
        const results = list.results || []
        results.forEach(item => {
          if (item.aligorthm_result) {
            item.aligorthm_result = JSON.parse(item.aligorthm_result)
          }
        })
        this.receiveList.list = list.results
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.tableLoading = false
      }
    },
    closeReceiveModal () {
      this.receiveModal.visible = false
      this.receiveModal.record = null
    },
    receiveRecord (record) {
      this.receiveModal.visible = true
      this.receiveModal.record = record
    },
    async sureReceive () {
      try {
        this.receiveModal.confirmLoading = true
        const userInfo = getSession('risUserInfo', 'object') || undefined
        if (!isObject(userInfo) || !this.receiveModal.record) {
          throw Error('获取用户信息失败')
        }
        const params = {
          id: this.receiveModal.record.id,
          userName: userInfo.user_name,
          userId: userInfo.id
        }
        await receiveAction(params)
        this.closeReceiveModal()
        toast({ msg: '领取成功', title: '操作提示', type: 'success' })
        this.tabChange(2)
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.receiveModal.confirmLoading = false
      }
    },
    createSearchParams (searchForm) {
      const params = {}
      for(const key in searchForm) {
        const val = searchForm[key]
        if (key === 'startAndEndTime' && val.length > 1) {
          params['startDate'] = searchForm[key][0].format('YYYY-MM-DD')
          params['endDate'] = searchForm[key][1].format('YYYY-MM-DD')
        } else if (val) {
          params[key] = val
        }
      }
      return params
    },
    async getProcessList (pageNum = 1) {
      try {
        if (!isString(pageNum) || !isNumber(pageNum)) {
          pageNum = 1
        } else if (pageNum && pageNum !== this.processList.pageNumber) {
          this.processList.pageNumber = pageNum
        }
        const params = {
          userId: this.userId,
          pageNumber: this.processList.pageNumber,
          pageSize: this.processList.pageSize,
          status: 10,
          type: 2
        }
        const postParams = Object.assign(params, this.createSearchParams(this.processList.searchForm))
        this.processList.tableLoading = true
        delete postParams.startAndEndTime
        const list = await findPage(postParams)
        const results = list.results || []
        results.forEach(item => {
          if (item.aligorthm_result) {
            item.aligorthm_result = JSON.parse(item.aligorthm_result)
          }
          item.uploadMarkFileLoading = false
        })
        this.processList.list = list.results
        this.processList.totalRecord = list.totalRecord
        setCurrentUrl(Object.assign({ activeKey: this.activeKey }, postParams))
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.processList.tableLoading = false
      }
    },
    giveUpRecord (record) {
      this.abandonModal.visible = true
      this.abandonModal.record = record
    },
    async sureGiveUp () {
      try {
        if (!this.abandonModal.record) {
          throw Error('获取放弃的病例信息异常')
        }
        this.abandonModal.confirmLoading = true
        const { id } = this.abandonModal.record
        await giveUpAction({ id })
        this.abandonModal.visible = false
        toast({ msg: '操作成功', title: '操作提示', type: 'success'})
        await this.getProcessList(1)
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.abandonModal.confirmLoading = false
      }
    },
    async watchImage (record) {
      try {
        const data = await getWeasisUrlByFilmNo({ filmNo: record.film_no })
        if (!data) throw Error('获取weasis地址异常')
        return this.openWeasis({ weasis_url: data }, 'history')
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      }
    },
    downLoadSegement (record) {
      if (!record.algorithm_file) {
        toast({ msg: '暂无分割文件', title: '操作提示', type: 'warning' })
        return
      }
      downLoadFile(record.algorithm_file, '分割文件')
    },
    downLoadMarkFile (record) {
      if (!record.mark_file) {
        toast({ msg: '暂无标注文件', title: '操作提示', type: 'warning' })
        return
      }
      downLoadFile(record.mark_file, '标注文件')
    },
    showNormalModal (record) {
      this.normalModal.visible = true
      this.normalModal.record = record
    },
    async sureFeminine () {
      try {
        this.normalModal.confirmLoading = true
        await saveAction({
          id: this.normalModal.record.id,
          status: 100,
          inspection_result: null,
          description: null,
          attachment: null,
        })
        this.normalModal.visible = false
        await this.getPageList()
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.normalModal.confirmLoading = false
      }
    },
    showAbnormalModal (record) {
      this.abnormalModal.visible = true
      this.abnormalModal.record = record
      this.abnormalModal.onlyShowFlag = false
    },
    async surePositive () {
      try {
        this.abnormalModal.confirmLoading = true
        const params = {
          id: this.abnormalModal.record.id,
          inspection_result: '',
          description: '',
          attachment: [],
          status: 100
        }
        if (!this.abnormalModal.diseaseType || !isArray(this.abnormalModal.diseaseType)  || this.abnormalModal.diseaseType.length < 1) {
          throw Error('请选择诊断结果')
        }
        if (!this.abnormalModal.abnormalReason) {
          throw Error('请输入诊断描述')
        }
        if (this.abnormalModal.imageList.length < 1) {
          throw Error('请上传诊断依据')
        }
        params.inspection_result = JSON.stringify(this.abnormalModal.diseaseType)
        params.description = this.abnormalModal.abnormalReason
        this.abnormalModal.imageList.forEach(item => {
          params.attachment.push(item.url)
        })
        params.attachment = JSON.stringify(params.attachment)
        await saveAction(params)
        toast({ msg: '操作成功', title: '操作提示', type: 'success'})
        this.closeAbnormalModal()
        await this.getPageList()
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.abnormalModal.confirmLoading = false
      }
    },
    deleteImage (numIndex) {
      this.abnormalModal.imageList.splice(numIndex, 1)
    },
    previewImage (numIndex) {
      const imageTarget = this.abnormalModal.imageList[numIndex]
      if (imageTarget) viewerApi({ images: [imageTarget.url]})
    },
    async getMyList (pageNum = 1) {
      try {
        if (!isString(pageNum) || !isNumber(pageNum)) {
          pageNum = 1
        } else if (pageNum && pageNum !== this.myList.pageNumber) {
          this.myList.pageNumber = pageNum
        }
        const params = {
          pageNumber: this.myList.pageNumber,
          pageSize: this.myList.pageSize,
          userId: this.userId,
          type: 3
        }
        const postParams = Object.assign(params, this.createSearchParams(this.myList.searchForm))
        delete postParams.startAndEndTime
        this.myList.tableLoading = true
        const list = await findPage(postParams)
        const results = list.results || []
        results.map(item => {
          if (item.inspection_result) {
            item.inspection_result = JSON.parse(item.inspection_result)
          }
          if (item.aligorthm_result) {
            item.aligorthm_result = JSON.parse(item.aligorthm_result)
          }
          if (item.attachment) {
            item.attachment = JSON.parse(item.attachment)
          } else {
            item.attachment = []
          }
          item.uploadMarkFileLoading = false
        })
        this.myList.list = results
        this.myList.totalRecord = list.totalRecord
        setCurrentUrl(Object.assign({ activeKey: this.activeKey }, postParams))
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.myList.tableLoading = false
      }
    },
    async getAllList (pageNum = 1) {
      try {
        if (!isString(pageNum) || !isNumber(pageNum)) {
          pageNum = 1
        } else if (pageNum !== this.allList.pageNumber) {
          this.allList.pageNumber = pageNum
        }
        const params = {
          pageNumber: this.allList.pageNumber,
          pageSize: this.allList.pageSize,
          type: 4
        }
        const postParams = Object.assign(params, this.createSearchParams(this.allList.searchForm))
        delete postParams.startAndEndTime
        this.allList.tableLoading = true
        const list = await findPage(postParams)
        const results = list.results || []
        results.map(item => {
          if (item.inspection_result) {
            item.inspection_result = JSON.parse(item.inspection_result)
          }
          if (item.aligorthm_result) {
            item.aligorthm_result = JSON.parse(item.aligorthm_result)
          }
          if (item.attachment) {
            item.attachment = JSON.parse(item.attachment)
          } else {
            item.attachment = []
          }
          item.uploadMarkFileLoading = false
        })
        this.allList.list = list.results
        this.allList.totalRecord = list.totalRecord
        setCurrentUrl(Object.assign({ activeKey: this.activeKey }, postParams))
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.allList.tableLoading = false
      }
    },
    setSearchParams (activeKey, routerParams) {
      let searchForm = null
      const obj = { 1: 'receiveList', 2: 'processList', 3: 'myList', 4: 'allList' }
      const list = this[obj[activeKey]]
      searchForm = list.searchForm
      if (routerParams.pageNumber) {
        list.pageNumber = 1 * routerParams.pageNumber
      }
      if (routerParams.pageSize) {
        list.pageSize = 1 * routerParams.pageSize
      }
      if (!searchForm) return
      for (const key in searchForm) {
        if (key === 'startAndEndTime' && routerParams['startDate'] && routerParams['endDate']) {
          searchForm[key] = [moment(routerParams['startDate']), moment(routerParams['endDate'])]
          continue
        }
        if (key === 'hospitalId' && routerParams['hospitalId']) {
          searchForm[key] = 1 * routerParams['hospitalId']
          continue
        }
        if (key === 'userId' && routerParams['userId']) {
          searchForm[key] = 1 * routerParams['userId']
          continue
        }
        if (key === 'pageNumber' && routerParams['pageNumber']) {
          searchForm[key] = 1 * routerParams['pageNumber']
          continue
        }
        if (routerParams.hasOwnProperty(key) && routerParams[key]) {
          searchForm[key] = decodeURIComponent(routerParams[key])
        }
      }
    },
    async selectPaste (event) {
      try {
        let items = event.clipboardData && event.clipboardData.items
        let file = null
        if (!items || items.length === 0) throw Error('粘贴错误，请重新试试')
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            file = items[i].getAsFile()
            break
          }
        }
        if (!file) throw Error('粘贴内容非图片')
        const url = await uploadFile({ file: file })
        this.abnormalModal.imageList.push({ url })
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      }
    },
    async markFileUpload (record, file) {
      try {
        const params = {
          file: file,
          id: record.id
        }
        record.uploadMarkFileLoading = true
        await uploadMarkFile(params)
        toast({ msg: '上传标注文件成功', title: '操作提示', type: 'success'})
        await this.getPageList()
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        record.uploadMarkFileLoading = false
      }
    },
    showDiagnoseDetail (record) {
      this.abnormalModal.record = record
      this.abnormalModal.onlyShowFlag = true
      this.abnormalModal.visible = true
      this.abnormalModal.diseaseType = record.inspection_result
      const imageList = []
      record.attachment.forEach(item => {
        imageList.push({ url: item })
      })
      this.abnormalModal.imageList = imageList
      this.abnormalModal.abnormalReason = record.description
    },
    closeAbnormalModal () {
      this.abnormalModal.visible = false
      this.abnormalModal.diseaseType = []
      this.abnormalModal.imageList = []
      this.abnormalModal.abnormalReason = ''
      this.abnormalModal.record = null
      this.abnormalModal.onlyShowFlag = false
    },
    async setHospitalList () {
      try {
        const list = await getHospitalList()
        this.hospitalList = list
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      }
    },
    async setWriteDoctorList () {
      try {
        let doctorList = await getWriteDoctorList({ roleId: 9, pageNumber: 1, pageSize: 9999 })
        if (!doctorList || !doctorList.results) throw Error('获取医生列表失败')
        this.writeDoctorList = doctorList.results || []
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      }
    },
    clearTimer () {
      const timer = getLocal('screeningTimer')
      if (timer) {
        clearInterval(timer)
        localStorage.removeItem('screeningTimer')
      }
    },
    showImgNotMatchModal (record) {
      this.imgNotMatchModal.visible = true
      this.imgNotMatchModal.record = record
    },
    closeImgNotMatchModal () {
      this.imgNotMatchModal.visible = false
      this.imgNotMatchModal.record = null
      this.imgNotMatchModal.reason = ''
    },
    async sureImgNotMatch () {
      try {
        this.imgNotMatchModal.confirmLoading = true
        const params = {
          id: this.imgNotMatchModal.record.id,
          inspection_result: '',
          description: this.imgNotMatchModal.reason || '图像不符',
          attachment: JSON.stringify([]),
          status: 100
        }
        await saveAction(params)
        toast({ msg: '操作成功', title: '操作提示', type: 'success'})
        this.closeImgNotMatchModal()
        await this.getPageList()
      } catch (error) {
        toast({ msg: error.message, type: 'error' })
      } finally {
        this.imgNotMatchModal.confirmLoading = false
      }
    }
  },
  async mounted () {
    await this.setHospitalList()
    await this.setWriteDoctorList()
    const userAuth = getSession('userAuth', 'object') || undefined
    if (userAuth && isObject(userAuth) && Array.isArray(userAuth.roles)) {
      const role = userAuth.roles.find(item => item.rcode === 'ROLE_CHECK_SCREENING_REVIEW')
      if (role) {
        this.hasRoleScreeningReview = true
      }
    }
    const routerParams = getParamFromRoute(this.$route)
    const activeTab = 1 * (routerParams.activeKey || 1)
    const activeKey = parseInt(activeTab, 10)
    if (isNumber(activeKey) && activeKey >= 1 && activeKey <=4 ) {
      this.activeKey = activeKey
      this.setSearchParams(activeKey, routerParams)
      this.getPageList()
    }
    if (activeKey === 1) {
      const timer = setInterval(this.getReceivePageList, 6000)
      setLocal('screeningTimer', timer)
    }
    this.handleTableScroll('.content')
  },
  beforeDestroy () {
    console.log('我要销毁了')
    this.clearTimer()
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.appointmentCheckPage{
  display: flex;
  flex-direction: column;
  height: 100%;
  button[ant-click-animating-without-extra-node]:after {
    border: 0 none;
    opacity: 0;
    animation:none 0 ease 0 1 normal;
  }
  .tabsWrap{
    margin: 16px 16px 0 16px;
    padding: 16px 16px 0 16px;
    background-color: #fff;
    .ant-tabs-bar{
      margin-bottom: 0 !important;
      border-bottom: none !important;
    }
  }
  .ant-table-row-cell-break-word{
     padding: 4px 4px !important;
  }
  .searchForm{
    margin: 0 16px;
  }
  .header{
    margin-top: 1px;
    .ant-card-body{
      padding: 16px 0 !important;
    }
    .ant-form{
      .ant-row{
        margin: 0 0 0 10px !important;
        .ant-select-selection--multiple{
          margin-top: 0;
        }
        .ant-col-4{
          padding-right: @LeaveDistance;
        }
        .ant-col-5{
          padding-right: @LeaveDistance;
        }
        .ant-col-6{
          padding-right: @LeaveDistance;
        }
        .ant-col-7{
          padding-right: @LeaveDistance;
        }
        .ant-col-lg-12{
          text-align: right;
        }
      }
      .searchRow{
        .ant-col-4, .ant-col-xs-4{
          margin-top: 12px;
        }
      }
    }
    .clappseRow{
      display: none;
    }
  }
  .content{
    flex: 1;
    overflow: auto;
    margin-top: 16px;
    padding: 0 @LeaveDistance;
    table{
      background-color: #fff;
    }
  }
  .ant-calendar-picker{
    width: 100%;
  }
  .footer{
    padding: @LeaveDistance @LeaveDistance;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media screen and (max-width: 992px) {
    .ant-col-lg-12{
      text-align: left !important;
    }
    .clappseRow{
      display: block !important;
      padding-top: 10px;
      color: @primaryColor;
      text-align: center !important;
    }
    .ant-table-thead{
      tr{
        th{
          min-width: 90px;
        }
      }
    }
    .footer{
      padding: 8px 16px;
      flex-direction: column;
      align-items: flex-start;
      .static{
        display: none;
      }
    }
    .ant-col-4{
      width: 50%;
    }
    .ant-col-5{
      width: 50%;
    }
    .ant-col-6{
      width: 50%;
    }
    .ant-col-7{
      margin: 12px 0;
      width: 100%;
    }
    .ant-col-xs-4{
      width: 50%;
    }
  }
  .ant-select-selection--multiple .ant-select-selection__rendered {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__rendered ul {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-selection__choice {
    overflow: hidden;
  }
  .ant-select-selection--multiple .ant-select-search--inline {
    float: none;
    position: absolute;
  }
  .ant-select-selection--multiple {
    margin-top: 4px;
    max-height: 32px;
    overflow: hidden;
  }
  .ant-btn{
    position: static;
  }
}
.abnormalModal{
  .ant-modal-content{
    max-height: 700px;
  }
  .onlyImage{
    display: inline-flex;
    flex-wrap: wrap;
  }
  .pasteImage{
    width: 350px;
    border: 1px dashed #ccc;
    height: 200px;
    margin-bottom: 12px;
    margin-right: 10px;
    overflow: hidden;
    &:hover{
      border-color: #1890ff;
      cursor: pointer;
    }
    .imageWrap{
      overflow: hidden;
      position: relative;
      height: 100%;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .delAndPrev{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 100%;
        z-index: 100;
        background-color: rgba(0,0,0,.5);
        display: none;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
      &:hover .delAndPrev{
        display: flex;
      }
    }
    .pasteTip{
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      color: #999;
      &:hover{
        color: #1890ff;
      }
    }
  }
}
</style>